import { APP_NAME_INBOX } from '../../../enums/apps';

export const sortItems = (items = {}) =>
    Object.values(items || {}).sort((a = {}, b = {}) => b.updated_at - a.updated_at);
export const sortItemsByRecentMessage = (items = {}) =>
    Object.values(items || {}).sort(
        (a = {}, b = {}) => (b.recent_message_date || b.updated_at) - (a.recent_message_date || a.updated_at)
    );

export const selectByShownCount = (state, name, shownCount) => {
    if (name === APP_NAME_INBOX) {
        return sortItemsByRecentMessage(state[name]).slice(0, shownCount);
    }

    return sortItems(state[name]).slice(0, shownCount);
};
